import React from 'react';
import { Box, Typography } from '@mui/material';
import { CustomButton } from '../../../v2/MUI_custom_component';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';

const InvoiceCardComponent = ({ title = 'Invoices', showViewAll = true, invoiceData = [] }) => {
  const navigate = useNavigate();

  const handleViewAll = () => {
    navigate('/invoice-list');
  };

  const handleViewDetails = (invoice) => {
    navigate(`/invoice-detail/${invoice.invoice_id}`);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      {invoiceData?.length > 0 && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography variant='h2'>{title}</Typography>
          {showViewAll && (
            <CustomButton
              label='View all'
              variant='text'
              color='primary'
              onClick={handleViewAll}
              size='small'
            />
          )}
        </Box>
      )}
      <Box
        sx={{
          display: 'flex',
          gap: 1,
          overflowX: { xs: 'scroll' },
          pb: 1,
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': { display: 'none' },
        }}
      >
        {invoiceData?.map((data, index) => (
          <Box
            key={data.id || index}
            sx={{
              p: 1,
              borderRadius: 2,
              backgroundColor: '#fff',
              display: 'flex',
              flexDirection: 'column',
              gap: 0.5,
              width: '221px',
              minWidth: '221px',
              flexShrink: 0,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: 1,
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  justifyContent: 'space-between',
                  width: '100%',
                }}
              >
                <Typography variant='labelM'>
                  {dayjs(data?.date_of_invoice).format('DD MMM YYYY')}
                </Typography>
                <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-end' }}>
                  <Typography variant='labelM' sx={{ color: '#666' }}>
                    Order ID
                  </Typography>
                  <Typography variant='p3'>{data?.order_id || '-'}</Typography>
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                marginTop: 1,
              }}
            >
              <Typography
                variant='labelM'
                sx={{
                  color: '#666',
                  minWidth: { xs: '80px', md: '100px' },
                }}
              >
                {data?.quantity?.[0]?.label || 'Invoice Qty.'}
              </Typography>
              <Typography variant='p3'>
                {data?.quantity?.[0]?.value || '--'}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                paddingBottom: 1,
              }}
            >
              <Typography
                variant='labelM'
                sx={{
                  color: '#666',
                  minWidth: { xs: '80px', md: '100px' },
                }}
              >
                Invoice No.
              </Typography>
              <Typography variant='p3'>{data?.invoice_no || '--'}</Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 'auto' }}>
              <CustomButton
                label='View Details'
                variant='text'
                color='primary'
                size='small'
                fullWidth
                onClick={() => handleViewDetails(data)}
              />
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default InvoiceCardComponent;
